import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function RewardsBulkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="1 0 21 21"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.4"
        d="M21.2483 18.47L19.5983 18.86C19.2283 18.95 18.9383 19.23 18.8583 19.6L18.5083 21.07C18.3183 21.87 17.2983 22.12 16.7683 21.49L13.7783 18.05C13.5383 17.77 13.6683 17.33 14.0283 17.24C15.7983 16.81 17.3883 15.82 18.5583 14.41C18.7483 14.18 19.0883 14.15 19.2983 14.36L21.5183 16.58C22.2783 17.34 22.0083 18.29 21.2483 18.47Z"
        fill="currentcolor"
      />
      <path
        opacity="0.4"
        d="M2.69919 18.47L4.34919 18.86C4.71919 18.95 5.00919 19.23 5.08919 19.6L5.43919 21.07C5.62919 21.87 6.64919 22.12 7.17919 21.49L10.1692 18.05C10.4092 17.77 10.2792 17.33 9.91919 17.24C8.14919 16.81 6.55919 15.82 5.38919 14.41C5.19919 14.18 4.85919 14.15 4.64919 14.36L2.42919 16.58C1.66919 17.34 1.93919 18.29 2.69919 18.47Z"
        fill="currentcolor"
      />
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 10.45 5.43 11.78 6.17 12.89C7.25 14.49 8.96 15.62 10.95 15.91C11.29 15.97 11.64 16 12 16C12.36 16 12.71 15.97 13.05 15.91C15.04 15.62 16.75 14.49 17.83 12.89C18.57 11.78 19 10.45 19 9C19 5.13 15.87 2 12 2ZM15.06 8.78L14.23 9.61C14.09 9.75 14.01 10.02 14.06 10.22L14.3 11.25C14.49 12.06 14.06 12.38 13.34 11.95L12.34 11.36C12.16 11.25 11.86 11.25 11.68 11.36L10.68 11.95C9.96 12.37 9.53 12.06 9.72 11.25L9.96 10.22C10 10.03 9.93 9.75 9.79 9.61L8.94 8.78C8.45 8.29 8.61 7.8 9.29 7.69L10.36 7.51C10.54 7.48 10.75 7.32 10.83 7.16L11.42 5.98C11.74 5.34 12.26 5.34 12.58 5.98L13.17 7.16C13.25 7.32 13.46 7.48 13.65 7.51L14.72 7.69C15.39 7.8 15.55 8.29 15.06 8.78Z"
        fill="currentcolor"
      />
    </SvgIcon>
  )
}
